import React from "react";
import { Auth } from "aws-amplify";

// Federated sign in from Amazon
class LoginWithAmazon extends React.Component {
  constructor(props) {
    super(props);
    this.signIn = this.signIn.bind(this);
  }

  signIn() {
    Auth.federatedSignIn({ provider: "LoginWithAmazon" });
  }

  render() {
    return <span onClick={this.signIn}>{this.props.children}</span>;
  }
}

export default LoginWithAmazon;
